
// changes
export default function MapLegend(props) {
  return (
    <svg viewBox="40 0 250 25" height="25" width="380" align="center" {...props}>
      <text
        x="5"
        y="12"
        style={{
          width: '57px',
          height: '16px',
          fontWeight: 400,
          fontSize: '12.64px',
        }}
      >
        Very High
      </text>
      <rect
        x="95"
        y="0"
        width="16"
        height="16"
        fill="#C40000"
      stroke="#990000"
        strokeWidth="1px"
      ></rect>
      <rect
        x="124"
        y="0"
        width="16"
        height="16"
        fill="#FB8D7B"
        stroke="#990000"
        strokeWidth="1px"
      ></rect>
     
<rect
           x="152"
        y="0"
        width="16"
        height="16"
        fill="#FFFFF0"
        stroke="#AD8D01"
        strokeWidth="1px"
      ></rect>
<rect
        x="180"
        y="0"
        width="16"
        height="16"
        fill="#6CB2A2"
        stroke="#0D5E4F"
        strokeWidth="1px"
      ></rect>
      
      <rect
        x="208"
        y="0"
        width="16"
        height="16"
       fill="#218371"
        stroke="#0D5E4F"
        strokeWidth="1px"
      ></rect>


      <text
        x="240"
        y="12"
        style={{
          width: '57px',
          height: '16px',
          fontWeight: 400,
          fontSize: '12.64px',
        }}
      >
        Minimal
      </text>
      
    </svg>
  )
}
